import type { FlowClient, FlowCustodian, FlowInstrument, Transaction } from "../../../../../stores/flowsStore";

export interface TradeRow {
  id: string;
  transaction_type: "buy" | "sell";
  client_id: string;
  custodian_id: string;
  instrument_isin: string;
  side: "buy" | "sell";
  amount: number;
  currency: string;
}

export interface FXSpotRow {
  id: string;
  client_id: string;
  custodian_id: string;
  buy_amount: number;
  buy_currency: string;
  sell_currency: string;
}

export interface WireTransferRow {
  id: string;
  client_id: string;
  amount: number;
  currency: string;
  from_custodian_id: string;
  to_custodian_id: string;
}

export const CURRENCIES = ["USD", "EUR", "GBP", "ILS", "CHF", "JPY", "AUD", "CAD"];

// Props interfaces for sub-components
export interface TradesAccordionProps {
  expanded: boolean;
  onAccordionChange: () => void;
  tradeRows: TradeRow[];
  clients: FlowClient[];
  custodians: FlowCustodian[];
  instruments: FlowInstrument[];
  handleTradeChange: (id: string, field: keyof TradeRow, value: string | number) => void;
  handleAddTradeRow: () => void;
  handleRemoveTradeRow: (id: string) => void;
  handleReAddTradeRow: (row: TradeRow) => void;
}

export interface FXSpotAccordionProps {
  expanded: boolean;
  onAccordionChange: () => void;
  fxRows: FXSpotRow[];
  clients: FlowClient[];
  custodians: FlowCustodian[];
  handleFXChange: (id: string, field: keyof FXSpotRow, value: string | number) => void;
  handleAddFXRow: () => void;
  handleRemoveFXRow: (id: string) => void;
  handleReAddFXRow: (row: FXSpotRow) => void;
}

export interface WireTransferAccordionProps {
  expanded: boolean;
  onAccordionChange: () => void;
  wireRows: WireTransferRow[];
  clients: FlowClient[];
  custodians: FlowCustodian[];
  handleWireChange: (id: string, field: keyof WireTransferRow, value: string | number) => void;
  handleAddWireRow: () => void;
  handleRemoveWireRow: (id: string) => void;
  handleReAddWireRow: (row: WireTransferRow) => void;
}

export interface PendingTransactionsSectionProps {
  filteredTransactions: Transaction[];
  clients: FlowClient[];
  custodians: FlowCustodian[];
  clientFilter: string;
  setClientFilter: (value: string) => void;
  custodianFilter: string;
  setCustodianFilter: (value: string) => void;
  typeFilter: string;
  setTypeFilter: (value: string) => void;
  statusFilter: string;
  setStatusFilter: (value: string) => void;
  handleOpenSubmitBundle: (txn: Transaction) => void;
  deleteTransaction: (identifier: string) => void;
  getTypeLabel: (type: string) => string;
}
